import { render, staticRenderFns } from "./show-works-info.vue?vue&type=template&id=c692ec68&scoped=true&"
import script from "./show-works-info.vue?vue&type=script&lang=js&"
export * from "./show-works-info.vue?vue&type=script&lang=js&"
import style0 from "./show-works-info.vue?vue&type=style&index=0&id=c692ec68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c692ec68",
  null
  
)

export default component.exports